import {useAppDispatch, useAppSelector} from '../../../../redux/hooks';
import {RootState} from '../../../../redux/store';
import Input from '../../../../Atoms/Input';
import {
    setAbilityValue,
    setCharacterSheetValue,
    setSkillValue, spendMana
} from '../../../../redux/slices/character/characterSlice';
import React from 'react';
import {
    calculateProficiency,
    calculateThrowBonus,
    getMaxManaAmount
} from '../../../../Helper/helperFunctions';
import {VeneCheckbox} from "../../../../Atoms/VeneCheckbox";
import {AutoFixHighSharp, FavoriteSharp, WaterDropSharp} from "@mui/icons-material";
import {PopUp} from "../../../../Atoms/PopUp";
import {TextEditor} from "../../../../Atoms/TextEditor";
import _ from "lodash";

interface CharacterSheetProps {

}

interface Feature {
    title: string,
    level: number,
    desc: string
}

export const CharacterSheet = (props: CharacterSheetProps) => {
    const character = useAppSelector((state: RootState) => state.character);
    const dispatch = useAppDispatch();

    const [ areDetailsVisible, setAreDetailsVisible ] = React.useState<boolean>(false);
    const [ selectedFeature, setSelectedFeatures ] = React.useState<Feature>({
        title: '',
        level: 0,
        desc: ''
    });
    
    const setCurrentMana = (event: any) => {
        if (getMaxManaAmount()) {
            if ((Number(event.target.value) <= getMaxManaAmount()) && Number(event.target.value) >= 0) {
                dispatch(setCharacterSheetValue({
                    initiative: character.CharacterSheet.initiative,
                    armorClass: character.CharacterSheet.armorClass,
                    lifepoints: character.CharacterSheet.lifepoints,
                    temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                    currentHitpoints: character.CharacterSheet.currentHitpoints,
                    currentMana: Number(event.target.value),
                    spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                    spellSaveDc: character.CharacterSheet.spellSaveDc,
                    languages: character.CharacterSheet.languages
                }))
            } else if ((Number(event.target.value) > getMaxManaAmount()) && Number(event.target.value) >= 0) {
                dispatch(setCharacterSheetValue({
                    initiative: character.CharacterSheet.initiative,
                    armorClass: character.CharacterSheet.armorClass,
                    lifepoints: character.CharacterSheet.lifepoints,
                    temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                    currentHitpoints: character.CharacterSheet.currentHitpoints,
                    currentMana: getMaxManaAmount(),
                    spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                    spellSaveDc: character.CharacterSheet.spellSaveDc,
                    languages: character.CharacterSheet.languages
                }))
            } else if ((Number(event.target.value) <= getMaxManaAmount()) && Number(event.target.value) < 0) {
                dispatch(setCharacterSheetValue({
                    initiative: character.CharacterSheet.initiative,
                    armorClass: character.CharacterSheet.armorClass,
                    lifepoints: character.CharacterSheet.lifepoints,
                    temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                    currentHitpoints: character.CharacterSheet.currentHitpoints,
                    currentMana: 0,
                    spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                    spellSaveDc: character.CharacterSheet.spellSaveDc,
                    languages: character.CharacterSheet.languages
                }))
            }
        } else {
            dispatch(setCharacterSheetValue({
                initiative: character.CharacterSheet.initiative,
                armorClass: character.CharacterSheet.armorClass,
                lifepoints: character.CharacterSheet.lifepoints,
                temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                currentHitpoints: character.CharacterSheet.currentHitpoints,
                currentMana: 0,
                spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                spellSaveDc: character.CharacterSheet.spellSaveDc,
                languages: character.CharacterSheet.languages
            }))
        }
    }

    const handleProfCheckboxSkills = (skill: any, returnedState: number) => {
        dispatch(setSkillValue({
            skill_to_characterSheetId: Number(skill.skill_to_characterSheetId),
            value: Number(skill.value),
            proficiencyAmount: Number(returnedState)

        }))
    }
    
    const calculateAbilityValue = (ability: any, value: number) => {
        switch (ability.Ability.abilityName) {
            case 'Stärke': {
                const athletik = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Athletik');
                if (athletik) {
                    const athletikDiff = Math.abs(ability.value - athletik!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: athletik.skill_to_characterSheetId,
                        value: athletikDiff + value,
                        proficiencyAmount: athletik.proficiencyAmount
                    }))
                }
                break;
            }
            case 'Geschick': {
                const fingerfertigkeit = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Fingerfertigkeit');
                const akrobatik = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Akrobatik');
                const schleichen = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Schleichen');
                if (fingerfertigkeit) {
                    const fingerfertigkeitDiff = Math.abs(ability.value - fingerfertigkeit!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: fingerfertigkeit.skill_to_characterSheetId,
                        value: fingerfertigkeitDiff + value,
                        proficiencyAmount: fingerfertigkeit.proficiencyAmount
                    }))
                }
                if (akrobatik) {
                    const akrobatikDiff = Math.abs(ability.value - akrobatik!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: akrobatik.skill_to_characterSheetId,
                        value: akrobatikDiff + value,
                        proficiencyAmount: akrobatik.proficiencyAmount
                    }))
                }
                if (schleichen) {
                    const schleichenDiff = Math.abs(ability.value - schleichen!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: schleichen.skill_to_characterSheetId,
                        value: schleichenDiff + value,
                        proficiencyAmount: schleichen.proficiencyAmount
                    }))
                }
                break;
            }
            case 'Intelligenz': {
                const arcana = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Arcana');
                const geschichte = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Geschichte');
                const naturkunde = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Naturkunde');
                const religion = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Religion');
                const untersuchen = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Untersuchen');
                if (arcana) {
                    const arcanaDiff = Math.abs(ability.value - arcana!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: arcana.skill_to_characterSheetId,
                        value: arcanaDiff + value,
                        proficiencyAmount: arcana.proficiencyAmount
                    }))
                }
                if (geschichte) {
                    const geschichteDiff = Math.abs(ability.value - geschichte!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: geschichte.skill_to_characterSheetId,
                        value: geschichteDiff + value,
                        proficiencyAmount: geschichte.proficiencyAmount
                    }))
                }
                if (naturkunde) {
                    const naturkundeDiff = Math.abs(ability.value - naturkunde!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: naturkunde.skill_to_characterSheetId,
                        value: naturkundeDiff + value,
                        proficiencyAmount: naturkunde.proficiencyAmount
                    }))
                }
                if (religion) {
                    const religionDiff = Math.abs(ability.value - religion!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: religion.skill_to_characterSheetId,
                        value: religionDiff + value,
                        proficiencyAmount: religion.proficiencyAmount
                    }))
                }
                if (untersuchen) {
                    const untersuchenDiff = Math.abs(ability.value - untersuchen!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: untersuchen.skill_to_characterSheetId,
                        value: untersuchenDiff + value,
                        proficiencyAmount: untersuchen.proficiencyAmount
                    }))
                }
                break;
            }
            case 'Weisheit' : {
                const einsicht = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Einsicht');
                const medizin = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Medizin');
                const tierpflege = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Tierpflege');
                const wahrnehmung = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Wahrnehmung');
                const ueberleben = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Überleben');
                if (einsicht) {
                    const einsichtDiff = Math.abs(ability.value - einsicht!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: einsicht.skill_to_characterSheetId,
                        value: einsichtDiff + value,
                        proficiencyAmount: einsicht.proficiencyAmount
                    }))
                }
                if (medizin) {
                    const medizinDiff = Math.abs(ability.value - medizin!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: medizin.skill_to_characterSheetId,
                        value: medizinDiff + value,
                        proficiencyAmount: medizin.proficiencyAmount
                    }))
                }
                if (tierpflege) {
                    const tierpflegeDiff = Math.abs(ability.value - tierpflege!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: tierpflege.skill_to_characterSheetId,
                        value: tierpflegeDiff + value,
                        proficiencyAmount: tierpflege.proficiencyAmount
                    }))
                }
                if (wahrnehmung) {
                    const wahrnehmungDiff = Math.abs(ability.value - wahrnehmung!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: wahrnehmung.skill_to_characterSheetId,
                        value: wahrnehmungDiff + value,
                        proficiencyAmount: wahrnehmung.proficiencyAmount
                    }))
                }
                if (ueberleben) {
                    const ueberlebenDiff = Math.abs(ability.value - ueberleben!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: ueberleben.skill_to_characterSheetId,
                        value: ueberlebenDiff + value,
                        proficiencyAmount: ueberleben.proficiencyAmount
                    }))
                }
                break;
            }
            case 'Charisma': {
                const einschuechtern = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Einschüchtern');
                const ueberzeugen = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Überzeugen');
                const unterhalten = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Unterhalten');
                const taeuschen = character.CharacterSheet.skill_to_characterSheet.find((skill: any) => skill.Skill.skillName === 'Täuschen');

                if (einschuechtern) {
                    const einschuechternDiff = Math.abs(ability.value - einschuechtern!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: einschuechtern.skill_to_characterSheetId,
                        value: einschuechternDiff + value,
                        proficiencyAmount: einschuechtern.proficiencyAmount
                    }))
                }
                if (ueberzeugen) {
                    const ueberzeugenDiff = Math.abs(ability.value - ueberzeugen!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: ueberzeugen.skill_to_characterSheetId,
                        value: ueberzeugenDiff + value,
                        proficiencyAmount: ueberzeugen.proficiencyAmount
                    }))
                }
                if (unterhalten) {
                    const unterhaltenDiff = Math.abs(ability.value - unterhalten!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: unterhalten.skill_to_characterSheetId,
                        value: unterhaltenDiff + value,
                        proficiencyAmount: unterhalten.proficiencyAmount
                    }))
                }
                if (taeuschen) {
                    const taeuschenDiff = Math.abs(ability.value - taeuschen!.value);
                    dispatch(setSkillValue({
                        skill_to_characterSheetId: taeuschen.skill_to_characterSheetId,
                        value: taeuschenDiff + value,
                        proficiencyAmount: taeuschen.proficiencyAmount
                    }))
                }
                break;

            }
        }

        dispatch(setAbilityValue({
            ability_to_characterSheetId: Number(ability.ability_to_characterSheetId),
            value: Number(value),
            proficiencyAmount: Number(ability.proficiencyAmount)
        }))
    }

    const handleProfCheckboxAbility = (ability: any, returnedState: number) => {
        dispatch(setAbilityValue({
            ability_to_characterSheetId: Number(ability.ability_to_characterSheetId),
            value: Number(ability.value),
            proficiencyAmount: Number(returnedState)
        }))
    }


    const renderOneFeature = (feature: Feature) => {
        return (
            <>
                <div className='character_single_action' onClick={ () => {
                    setSelectedFeatures(feature);
                    setAreDetailsVisible(true);
                }}>
                    <div className='character_single_action_title'>
                        { feature.title }
                    </div>
                    <div className='character_single_action_Level'>
                        Level: { feature.level }
                    </div>
                </div>
            </>
        )
    }

    const renderAllFeatures = () => {
        const html = [];
        let featureList: Feature[] = [];

        for (const classEntry of character.character_to_class) {
            if (classEntry.Class) {
                for (const classFeature of classEntry.Class.ClassFeature) {
                    if (classFeature.onLevel <= classEntry.level) {
                        featureList.push({
                            title: classFeature.classFeatureName,
                            desc: classFeature.classFeatureDesc,
                            level: classFeature.onLevel
                        })
                    }
                }
            }
            if (classEntry.Subclass) {
                for (const subclassFeature of classEntry.Subclass.SubclassFeature) {
                    if (subclassFeature.onLevel <= classEntry.level) {
                        featureList.push({
                            title: subclassFeature.subclassFeatureName,
                            desc: subclassFeature.subclassFeatureDesc,
                            level: subclassFeature.onLevel
                        })
                    }
                }
            }
        }

        if (character.Race) {
            for (const raceFeature of character.Race.raceFeatures) {
                featureList.push({
                    title: raceFeature.raceFeatureName,
                    desc: raceFeature.raceFeatureDesc,
                    level: 1
                })
            }
        }

        if (character.Subrace) {
            for (const raceFeature of character.Subrace.subraceFeatures) {
                featureList.push({
                    title: raceFeature.subraceFeatureName,
                    desc: raceFeature.subraceFeatureDesc,
                    level: 1
                })
            }
        }

        featureList.sort((feature1: Feature, feature2: Feature) => feature1.level - feature2.level);

        for (const feature of featureList) {
            html.push(renderOneFeature(feature))
        }

        return html
    }
    
    const castSpell = (spellCost: number) => {
        dispatch(spendMana(spellCost))
    }

    const renderSpellSaveStat = () => {
        const spellSaveHTML = [];
        let allUsedSpellAbilies: { abilityName: string, abilityValue: number }[] = [];

        // Durchsuche alle Spells die der Charakter besitzt
        for (const spell of character.CharacterSheet.Spell) {
            // Wenn dieser Spell eine Spellliste hat
            if (spell.spellListType !== null) {
                // Suche den Wert der entsprechenden Fähigkeit
                const foundAbility = character.CharacterSheet.ability_to_characterSheet.find(atc => Number(atc.Ability.abilityId) === Number(spell.spellListType!.Ability.abilityId));
                // Wenn der Wert gefunden wurde
                if (foundAbility) {
                    const isAlreadyInList = allUsedSpellAbilies.find(usedAbility => usedAbility.abilityName === foundAbility.Ability.abilityName) === undefined;
                    // Wenn Wert bereits in der Liste ist
                    if (isAlreadyInList) {
                        // neuer Eintrag im Array
                        allUsedSpellAbilies.push({
                            abilityName: foundAbility.Ability.abilityName,
                            abilityValue: foundAbility.value
                        })
                    }
                }
            }
        }

        if (allUsedSpellAbilies.length > 0) {
            for (const spellAbility of allUsedSpellAbilies) {
                const calculatedAbilityValue = calculateThrowBonus(spellAbility.abilityValue) > 0 ? calculateThrowBonus(spellAbility.abilityValue) : 0;

                spellSaveHTML.push(
                    <div className="character_single_combat_stat" key={`${spellAbility.abilityName}`}>
                        <div className="bonus_title"><b>Werte für {spellAbility.abilityName} Zauber</b></div>
                        <div>
                            Angriff
                        </div>
                        <div>
                            1D20+{ calculatedAbilityValue + character.CharacterSheet.spellAttackModifier + calculateProficiency(1, character) }
                        </div>
                        <div>
                            Schwierigkeitsgrad
                        </div>
                        <div>
                            { calculatedAbilityValue + character.CharacterSheet.spellSaveDc + 8 + calculateProficiency(1, character) }
                        </div>
                    </div>
                )
            }
        } else {
            spellSaveHTML.push(
                <div>
                    Du hast noch keine Zauber angelegt
                </div>
            )
        }

        return spellSaveHTML;
    }

    const renderSkills = () => {
        const skillHTML = [];
        const skillList = _.cloneDeep(character.CharacterSheet.skill_to_characterSheet)
        const sortedSkillList = skillList.sort((stcA, stcB) => {
            const nameA = stcA.Skill.skillName.toUpperCase();
            const nameB = stcB.Skill.skillName.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }

            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });

        for (const skill of sortedSkillList) {
            skillHTML.push(
                <div className='character_skill_single'>
                    <VeneCheckbox checked={skill.proficiencyAmount} onClick={(returnedState: number) => handleProfCheckboxSkills(skill, returnedState)}/>
                    <span className='character_skill_name'>{skill.Skill.skillName}</span>
                    <input className='character_skill_value' min={0} max={20} value={skill.value} type='number' onChange={(event) => dispatch(setSkillValue({
                        skill_to_characterSheetId: Number(skill.skill_to_characterSheetId),
                        value: Number(event.target.value),
                        proficiencyAmount: Number(skill.proficiencyAmount)
                    }))}/>
                    <input className='character_skill_bonus' value={calculateProficiency(skill.proficiencyAmount, character) + calculateThrowBonus(skill.value)!} disabled={true}/>
                </div>
            )
        }

        return skillHTML;
    }

    const renderAbilities = () => {
        const abilityHTML = [];
        const abilityList = _.cloneDeep(character.CharacterSheet.ability_to_characterSheet);
        const sortedAbilityList = abilityList.sort((atcA, atcB) => Number(atcA.Ability.abilityId) - Number(atcB.Ability.abilityId));

        for (const ability of sortedAbilityList) {
            abilityHTML.push(
                <div className='character_single_stat'>
                    <span>{ability.Ability.abilityName}</span>
                    <Input minValue={0} maxValue={20} className='ability_input' value={ability.value} onChange={(event: any) => calculateAbilityValue(ability, Number(event.target.value))}/>
                    <p style={{ marginTop: '2px' }}>{calculateThrowBonus(ability.value)!}</p>
                    <div className='character_single_stat_prof'>
                        <VeneCheckbox checked={ability.proficiencyAmount} onClick={(returnedState: number) => handleProfCheckboxAbility(ability, returnedState)} />
                    </div>
                </div>
            )
        }

        return abilityHTML;
    }

    const calculateInitativeThrowBonus = () => {
        let returnString = ""
        const dexEntry = character.CharacterSheet.ability_to_characterSheet.find(atc => atc.Ability.abilityName === "Geschick");
        if (dexEntry !== undefined) {
            const value = calculateThrowBonus(dexEntry.value) + character.CharacterSheet.initiative;
            returnString += `${value > 0 ? "+" :  ""}${value > 0 ? value : ""}`;
        }

        return returnString;
    }

    return (
        <div className='character_main_block'>
            {areDetailsVisible && (
                <PopUp onClose={() => setAreDetailsVisible(false)} title={"Beschreibung"}>
                    <div>
                        <div className='row justify-content-between mt-2'>
                            <div className='col-2'>
                                <b>{selectedFeature.title}</b>
                            </div>
                            <div className='col-2'>
                                Level: {selectedFeature.level}
                            </div>
                        </div>
                        <TextEditor disabled={true} onChange={() => {
                            return
                        }} value={selectedFeature.desc}/>
                    </div>
                </PopUp>
            )}
            
            <div className='character_main_stats'>
                { renderAbilities() }
                <div className='character_main_stats_vitals'>
                    <div className='character_vitals_hp'>
                        <FavoriteSharp className='vitals_hp_icon'/>
                        <input className='character_vitals_hp_current'
                               value={character.CharacterSheet.currentHitpoints}
                               onChange={(event) => dispatch(setCharacterSheetValue({
                                   initiative: character.CharacterSheet.initiative,
                                   armorClass: character.CharacterSheet.armorClass,
                                   lifepoints: character.CharacterSheet.lifepoints,
                                   temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                   currentHitpoints: Number(event.target.value),
                                   currentMana: character.CharacterSheet.currentMana,
                                   spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                                   spellSaveDc: character.CharacterSheet.spellSaveDc,
                                   languages: character.CharacterSheet.languages
                               }))}/>
                        <label style={{marginLeft: '5px', marginRight: '5px'}}>/</label>
                        <input className='character_vitals_hp_max'
                               value={character.CharacterSheet.lifepoints}
                               onChange={(event) => dispatch(setCharacterSheetValue({
                                   initiative: character.CharacterSheet.initiative,
                                   armorClass: character.CharacterSheet.armorClass,
                                   lifepoints: Number(event.target.value),
                                   temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                   currentHitpoints: character.CharacterSheet.currentHitpoints,
                                   currentMana: character.CharacterSheet.currentMana,
                                   spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                                   spellSaveDc: character.CharacterSheet.spellSaveDc,
                                   languages: character.CharacterSheet.languages
                               }))}/>
                    </div>
                    <div className='character_vitals_mana'>
                        <WaterDropSharp className='vitals_mana_icon'/>
                        <input className='character_vitals_mana_current'
                               value={character.CharacterSheet.currentMana}
                               min={0}
                               max={getMaxManaAmount()}
                               onChange={(event) => setCurrentMana(event)}/>
                        <label style={{marginLeft: '5px', marginRight: '5px'}}>/</label>
                        <input className='mana-input'
                               value={getMaxManaAmount()}
                               disabled={true}
                        />
                    </div>
                </div>
                <div className='character_main_stats_prof'>
                    <span>Übung</span>
                    <span>+{calculateProficiency(1, character)}</span>
                </div>
            </div>
            <div className='character_main_stats_lower_section mt-2'>
                <div className='character_skills'>
                    <div className='character_skills_title'>
                        <b>Spielwerte</b>
                    </div>
                    <div className='character_skill_single'>
                        <span style={{width: '2.25rem'}}><b>Prof.</b></span>
                        <span style={{width: '8rem', marginLeft: '1.5rem', textAlign: 'start'}}><b>Skill</b></span>
                        <span style={{width: '4rem'}}><b>Wert</b></span>
                        <span style={{width: '3rem'}}><b>Bonus</b></span>
                    </div>
                    { renderSkills() }
                </div>
                <div className='character_combat_stats'>
                    <div className='character_combat_stats_title'>
                        <b>Stats</b>
                    </div>
                    <div className='character_single_combat_stat'>
                        <div className="bonus_title"><label>Rüstungsklasse</label></div>
                        <div className='armor'>
                            <input value={character.CharacterSheet.armorClass}
                                   onChange={(event) => dispatch(setCharacterSheetValue({
                                       initiative: character.CharacterSheet.initiative,
                                       armorClass: Number(event.target.value),
                                       lifepoints: character.CharacterSheet.lifepoints,
                                       temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                       currentHitpoints: character.CharacterSheet.currentHitpoints,
                                       currentMana: character.CharacterSheet.currentMana,
                                       spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                                       spellSaveDc: character.CharacterSheet.spellSaveDc,
                                       languages: character.CharacterSheet.languages
                                   }))}/>
                        </div>
                    </div>
                    <div className='character_single_combat_stat'>
                        <div className="bonus_title"><b>Initiative</b></div>
                        <div>1D20{ calculateInitativeThrowBonus() }</div>
                    </div>
                    { renderSpellSaveStat() }
                </div>
                <div className='character_actions'>
                    <div className='character_action_title'><b>Aktionen</b></div>
                    <div className="character_feature_list">
                        { renderAllFeatures() }
                    </div>
                </div>
                <div className='character_spells_shortlist'>
                    <div className='character_spells_shortlist_title'><b>Zauber</b></div>
                    <div className='character_single_spell'>
                        <div className='character_single_spell_name'>
                            <b>Name</b>
                        </div>
                        <div className='character_single_spell_cost'>
                            <b>Kosten</b>
                        </div>
                    </div>
                    {character.CharacterSheet.Spell.map((spell) => {
                        if (spell.isActive) {
                            return (
                                <div className='character_single_spell'>
                                    <div className='character_single_spell_name'>
                                        {spell.spellName}
                                    </div>
                                    <div className='character_single_spell_cost'>
                                        {spell.spellCost}
                                        <AutoFixHighSharp
                                            aria-disabled={character.CharacterSheet.currentMana - spell.spellCost < 0}
                                            titleAccess='Wirken' className='single_spell_use' onClick={() => {
                                            castSpell(spell.spellCost)
                                        }}/>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className="character_bonus_stats">
                    <div className='character_combat_stats_title'>
                        <b>Boni (von Ausrüstung oder sonstigen Umständen)</b>
                    </div>
                    <div className="bonus_fields">
                        <div className='character_single_combat_stat'>
                            <label>Bonus auf Initiative</label>
                            <div className='initiative_field'>
                                <input className=''
                                       value={character.CharacterSheet.initiative}
                                       onChange={(event) => dispatch(setCharacterSheetValue({
                                           initiative: Number(event.target.value),
                                           armorClass: character.CharacterSheet.armorClass,
                                           lifepoints: character.CharacterSheet.lifepoints,
                                           temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                           currentHitpoints: character.CharacterSheet.currentHitpoints,
                                           currentMana: character.CharacterSheet.currentMana,
                                           spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                                           spellSaveDc: character.CharacterSheet.spellSaveDc,
                                           languages: character.CharacterSheet.languages
                                       }))}
                                />
                            </div>
                        </div>
                        <div className='character_single_combat_stat'>
                            <label>Bonus auf Zauberrettungsbonus</label>
                            <div className='spellsave_field'>
                                <input className=''
                                       value={character.CharacterSheet.spellSaveDc}
                                       onChange={(event) => dispatch(setCharacterSheetValue({
                                           initiative: character.CharacterSheet.initiative,
                                           armorClass: character.CharacterSheet.armorClass,
                                           lifepoints: character.CharacterSheet.lifepoints,
                                           temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                           currentHitpoints: character.CharacterSheet.currentHitpoints,
                                           spellAttackModifier: character.CharacterSheet.spellAttackModifier,
                                           currentMana: character.CharacterSheet.currentMana,
                                           spellSaveDc: Number(event.target.value),
                                           languages: character.CharacterSheet.languages
                                       }))}/>
                            </div>
                        </div>
                        <div className='character_single_combat_stat'>
                            <label>Bonus auf Zauberangriffsbonus</label>
                            <div className='spellsave_field'>
                                <input className=''
                                       value={character.CharacterSheet.spellAttackModifier}
                                       onChange={(event) => dispatch(setCharacterSheetValue({
                                           initiative: character.CharacterSheet.initiative,
                                           armorClass: character.CharacterSheet.armorClass,
                                           lifepoints: character.CharacterSheet.lifepoints,
                                           temporaryHitpoints: character.CharacterSheet.temporaryHitpoints,
                                           currentHitpoints: character.CharacterSheet.currentHitpoints,
                                           currentMana: character.CharacterSheet.currentMana,
                                           spellAttackModifier: Number(event.target.value),
                                           spellSaveDc: character.CharacterSheet.spellSaveDc,
                                           languages: character.CharacterSheet.languages
                                       }))}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}